import rootStore from '@vue-storefront/core/store'

export function afterRegistration ({ Vue, config, store, isServer }) {
  if (config.ipay.enabled) {
    let paymentMethod = {
      title: 'Masterpass Wallet',
      code: 'ipay_masterpass',
      cost: 0,
      costInclTax: 0,
      default: true,
      offline: false,
      is_server_method: false,
      img:'payment'
    }
    rootStore.dispatch('payment/addMethod', paymentMethod)
    if (config.ipay.applepay.enabled) {
      let applePayPaymentMethod = {
        title: 'ApplePay',
        code: 'ipay_applepay',
        cost: 0,
        costInclTax: 0,
        default: true,
        offline: false,
        is_server_method: false,
        img: 'applepay'
      }
      rootStore.dispatch('payment/addMethod', applePayPaymentMethod)
    }
    if (config.ipay.gpay.enabled) {
      let gPayPaymentMethod = {
        title: 'GPay',
        code: 'ipay_gpay',
        cost: 0,
        costInclTax: 0,
        default: true,
        offline: false,
        is_server_method: false,
        img: 'gpay'
      }
      rootStore.dispatch('payment/addMethod', gPayPaymentMethod)
    }
  }
}
